// extracted by mini-css-extract-plugin
export default {"cancelProcessStepDialog":"cancelProcessStepDialog-wJZzG"};